var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseFuseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dyjd7ims9a",
    d: "M5.46 16.869L24.166 2.98 42.93 16.87H5.459zM22.785 1.01c.842-.6 1.953-.604 2.781-.027l21.922 16.225c.543.365.904.99.904 1.698v22.026c0 .675-.543 1.224-1.211 1.224s-1.209-.549-1.209-1.224V19.316H2.42v27.736h44.76c.669 0 1.212.547 1.212 1.223 0 .675-.543 1.225-1.211 1.225H2.017C.905 49.5 0 48.586 0 47.459V18.907c0-.72.375-1.352.935-1.716zm9.559 20.927c.432 0 .79.217.838.496l.005.066v2.25h2.51c1.047 0 1.909.815 1.985 1.845l.005.149v13.053c0 1.318-1.072 2.39-2.39 2.39h-2.11v2.25c0 .311-.377.563-.843.563-.433 0-.79-.217-.838-.497l-.006-.066v-2.25h-2.11c-1.262 0-2.3-.985-2.384-2.227L27 39.797V26.744c0-1.1.894-1.994 1.993-1.994h2.506l.001-2.25c0-.31.378-.563.844-.563zm-.845 4.64h-2.67V40.36h2.67V26.577zm4.36 0h-2.672v13.781h2.673V26.58z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-464 -2394) translate(444 2374) translate(16 16) translate(4.5 4.5) translate(7.313 6.75)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#1A171B",
    xlinkHref: "#dyjd7ims9a"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseFuseIcon);
export default __webpack_public_path__ + "static/media/house_fuse_icon.db5b718f057a75aa9ccb87430734c466.svg";
export { ForwardRef as ReactComponent };